var _desc, _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSeychelles2X(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "71px",
    height: "48px",
    viewBox: "0 0 71 48",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Seychelles@2x") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Flags",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    transform: "translate(-831.000000, -498.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(70.000000, 70.000000)",
    fillRule: "nonzero",
    id: "Seychelles"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(761.000000, 428.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.88,47 L4.39,46.88 L70.86,16.27 L70.86,7.33 C70.86,3.81746899 68.012531,0.97 64.5,0.97 L46.6,0.97 L2.28,45.59 C2.73058418,46.1463086 3.27144843,46.6229452 3.88,47 Z",
    id: "Shape",
    fill: "#ED5565"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.24,1 C3.72746899,1 0.88,3.84746899 0.88,7.36 L0.88,41.63 C0.879560936,42.5448677 1.07743754,43.4489591 1.46,44.28 L24.15,1 L7.24,1 Z",
    id: "Shape",
    fill: "#4758A9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.1,1 L24.15,1 L1.45,44.28 C1.58977502,44.5858448 1.75362365,44.8801036 1.94,45.16 C2.05,45.32 2.16,45.47 2.28,45.62 L46.6,1 L25.1,1 Z",
    id: "Shape",
    fill: "#FFCE54"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Shape",
    fill: "#FFFFFF",
    points: "70.87 30.89 70.87 16.26 4.4 46.87"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.4,46.87 L3.99,47.06 C4.97182054,47.6488276 6.09514653,47.9599025 7.24,47.96 L64.51,47.96 C68.022531,47.96 70.87,45.112531 70.87,41.6 L70.87,30.9 L4.4,46.87 Z",
    id: "Shape",
    fill: "#57A863"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSeychelles2X);
export default __webpack_public_path__ + "static/media/Seychelles@2x.ae768a5bf4d60ffb705574e97cc92ec4.svg";
export { ForwardRef as ReactComponent };